/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import proptypes from 'prop-types';
const { string, func, number } = proptypes;
import { Price } from '@thd-olt-component-react/price';
import { extend } from '@thd-nucleus/data-sources';
import { AddTo, AddToListModel } from '@thd-olt-component-react/add-to';
import { SuperSkuMiniSwatches, SuperSku } from '@thd-olt-component-react/super-sku';
import { ProductSeeSimilarItems } from '@thd-olt-component-react/product-pod-group';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { NonBuyableQuoteCenter } from '@thd-olt-component-react/non-buyable-quote-center';
import {
  ProductPod,
  PodSticker,
  ProductATC,
  ProductRating,
  ProductSample,
  ProductIdentifier, ProductBadge, ProductSponsored,
  ProductImage, PodFooter, PodSection, ProductCompare,
  ProductCustomOptions, PodSpacer
} from '@thd-olt-component-react/product-pod';

export const ShopByRoomPod = ({
  itemId,
  parent,
  position,
  storeId,
  showSimilarItem,
}) => {

  return (
    <ProductPod
      itemId={itemId}
      hasSSKU
      analyticsData={{
        parent, position
      }}
      render={(pod) => (
        <>
          <PodSection columnAlign>
            <PodSticker position="top-left">
              <ProductBadge itemId={pod.itemId} storeId={storeId} />
            </PodSticker>
            <PodSticker position="top-right">
              <PodSpacer padding={['TOP', 'RIGHT']}>
                <AddTo
                  addToType="List"
                  products={[
                    {
                      itemId: pod.itemId,
                      quantity: 1
                    }
                  ]}
                  list={{ showCount: true, showIconButton: true }}
                />
              </PodSpacer>
            </PodSticker>
            <ProductImage
              itemId={pod.itemId}
              showSecondaryImage={pod.showSecondaryImage}
            />
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <div className="sui-w-40">
                <SuperSkuMiniSwatches
                  itemId={pod.itemId}
                  storeId={storeId}
                  onChange={pod.onChange}
                  onHover={pod.onSSKUHover}
                  numberOfMiniSwatches={4}
                />
              </div>
            </PodSpacer>
          </PodSection>
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="below"
                itemId={pod.itemId}
                brandTitleMaxLine={3}
                disableShopThisCollection
              />
            </PodSpacer>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductRating itemId={pod.itemId} />
            </PodSpacer>
            <PodSpacer minHeight="60px">
              <Price
                itemId={pod.itemId}
                type="simple"
                storeId={pod.storeId}
                showSimilarItem
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideBadge
                hideLimitPerOrder
                hideForProductTypes={['HDQC']}
                hideSavingsText
              />
            </PodSpacer>
          </PodSection>
          <PodFooter>
            <PodSpacer minHeight="124px" padding={['TOP']}>
              <FulfillmentPodStore itemId={pod.itemId} storeId={pod.storeId} />
              <FulfillmentPodShipping itemId={pod.itemId} storeId={pod.storeId} />
            </PodSpacer>
            <PodSpacer>
              <NonBuyableQuoteCenter itemId={pod.itemId} />
            </PodSpacer>
            <PodSpacer padding={['TOP']}>
              <ProductATC
                itemId={pod.itemId}
                storeId={storeId}
                showSimilarItem={showSimilarItem}
                outline
                ShowDisabledATC
              />
            </PodSpacer>
            <div className="sui-pt-0 sui-pb-2 sui-mb-5">
              <ProductSeeSimilarItems
                itemId={pod.itemId}
                position={position}
                productPodRef={pod.ref}
                storeId={storeId}
              />
            </div>
          </PodFooter>
        </>
      )}
    />
  );
};

ShopByRoomPod.dataModel = extend({},
  AddToListModel,
  ProductImage,
  Price,
  SuperSkuMiniSwatches,
  SuperSku,
  ProductATC,
  ProductPod,
  ProductRating,
  ProductCompare,
  ProductSample,
  ProductIdentifier,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  ProductCustomOptions,
  KeyProductFeatures,
  NonBuyableQuoteCenter
);

ShopByRoomPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  parent: string.isRequired,
  position: number.isRequired
};

ShopByRoomPod.defaultProps = {};

ShopByRoomPod.displayName = 'ShopByRoomPod';
